import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import notiPlugin from "./assets/js/noti.js";
import alertPlugin from "./assets/js/alert.js";
import commonJs from "./assets/js/common.js";
import axios from "./axios.js"

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store).use(router);
app.use(notiPlugin);
app.use(alertPlugin);
app.use(commonJs);

app.mount('#app');